import { useQuery } from "@tanstack/react-query";

import type { IContentCertificate } from "../types/content";
import { useGetEnv } from "./useEnv";
import request from "../utils/request";

export function useGetCertificates() {
  const env = useGetEnv();

  const query = useQuery({
    queryKey: ["certificates"],
    queryFn: async () => {
      return await request.make<{ data: IContentCertificate[] }>(
        encodeURI(
          `${env?.oasys_url}/api/v1/corp/items/certificates` +
            `?fields=id,name,download`
        )
      );
    },
    enabled: !!env,
  });

  return { ...query, data: query.data?.data };
}
